<template>
    <div>
        <div class="modal-container has-text-centered">
            <div class="has-text-centered">
                
                  
                    <div class="is-size-3">Welcome to</div >

                    <img class="top5" src="@/assets/img/Miimu logo.png" width="300"/><br/>

                    <div class="is-size-4"><b>We can’t wait to help you get started.</b></div>
                    
                    <div class="top20 is-size-5">
                        Our step-by-step guide will take you through the steps to creating your first miimu and your first bundle, along with tips for customizing your profile.
                    </div>

                    <div class="top20 is-size-4">
                        <b>Let’s capture some content!</b>
                    </div>
                   
                    <div  class="top20 button handCursor is-coolGreen" @click="start">
                        Start
                    </div>
                    &nbsp;
                    <div  class="top20 button handCursor" @click="cancel">
                        No Thanks
                    </div>

                    
            </div>
        </div>
    </div>

</template>

<script>
export default {
  props: {message: String, callBack: Function, payload: Object},
  methods: {

      start: function(){
        this.$parent.$parent.startTour()
        this.$emit('close')
      },
    
      cancel: function(){
          this.$emit('close')
      }
  }
}
</script>

<style scoped>
    #title{
        font-size: 1.5rem;
    }
    .modal-container{
        max-width: 700px;
        padding: 40px
    }
    .body-bott{
        position: absolute;
        right: 15px;
        bottom: 20px;
        width: 100%;
    }
    .notification{
        height: 100%;
    }
    #xButt{
        background-color: transparent !important;
        position: absolute;
        font-size: 2rem !important;
        right: 10px;
    }
    .delete::after{
        width: 1px;
        height: 100%
    }
     .delete::before{
        height: 1px;
        width: 100%
    }
   

</style>
